(function () {
    'use strict';
    var controllerId = 'incaricoAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', 'incarico', 'risorse', 'risorsaId', 'classi', 'classeId', incaricoAddEditFn]);

    function incaricoAddEditFn($scope, $uibModalInstance, datacontext, sectionMenu, incarico, risorse, risorsaId, classi, classeId) {
        $scope.incarico = {};
        $scope.edit = false;        

        if (incarico) {     //Edit
            $scope.incarico = incarico;
            $scope.edit = true;            
        }

        $scope.classi = classi;
        $scope.risorse = risorse;

        if ($scope.edit)
            $scope.titolo = 'ModificaIncarico';    
        else   // sono in modifica
            $scope.titolo = 'NuovoIncarico'; 


        //Parametro classeId utilizzato per impostare e bloccare selezione Classe
        //Utilizzato in caso di creazione unovo studente da view /app/classe/classeDetail.html
        if (classeId) {
            $scope.classeId = classeId;
            $scope.incarico.ClasseId = classeId;            
        }

        if (risorsaId) {
            $scope.risorsaId = risorsaId;
            $scope.incarico.RisorsaId = risorsaId;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addEditItem($scope.incarico);
                
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        

        function addEditItem(incarico) {
            if ($scope.edit) 
                return datacontext.incarico_update(incarico).then(function (data) {
                    if (!data) return null;

                    return data;
                });            
            else 
                return datacontext.incarico_add(incarico).then(function (data) {
                    if (!data) return null;

                    return data;
                });
        }
    }
})();